import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { IContact } from "../../models/BaseModel";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { Search } from "../../shared/Search";
import { IOpenForm } from "./Contact";
import { format } from "date-fns";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { LeadGenerateForm } from "./LeadGenerateForm";
import { Toolbar } from "primereact/toolbar";
import React from "react";
import { BulkUploadForm } from "./BulkUpload";
import { BulkLeadLeadGenerateForm } from "./BulkLeadGenerateForm";
import { Filter, IFilter } from "./Filter";

interface Iprops {
    setModal: (modal: IOpenForm) => void,
    toast: any,
    reload: boolean,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ data: [], count: 0, loading: false } as { data: IContact[], count: number, loading: boolean });
    const [text, setText] = useState<string | null>(null);
    const [openleadGenerateForm, setOpenleadGenerateForm] = useState({ singleData: {}, open: false } as IOpenForm);
    const [openleadBulkUpload, setOpenleadBulkUpload] = useState({ singleData: {}, open: false } as IOpenForm);
    const [selectedContacts, setSelectedContacts] = useState<IContact[]>([]);
    const [filter, setFilter] = useState<IFilter>({});

    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'id',
        sortOrder: -1
    });

    useEffect(() => {
        loadTableData();
    }, [text, lazyParams, filter, props.reload]);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const formattedFilter = {
            ...filter,
            fromDate: filter.fromDate ? format(new Date(filter.fromDate), 'yyyy-MM-dd') : undefined,
            toDate: filter.toDate ? format(new Date(filter.toDate), 'yyyy-MM-dd') : undefined,
        };
        const response = await Fetch("contact_person", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}${text ? '&text=' + text : ''}&filter=${JSON.stringify(formattedFilter)}`, props.toast);
        if (response) {
            const data: { contacts: IContact[], count: number } = await response.json();
            setTableData({ data: data.contacts, count: data.count, loading: false });
        } else {
            setTableData((prev) => ({ ...prev, loading: false, }));
        }
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: {} });
    };

    const openEdit = (rowData: IContact) => {
        props.setModal({ open: true, singleData: { ...rowData } });
    };

    const Remove = async (rowData: IContact) => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch(`contact_person/${rowData.id}`, "DELETE", null, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Contact Deleted", life: 3000 });
            loadTableData();
        }
    }

    const rejectFunc = () => { }

    const confirmDelete = (rowData: IContact) => {
        confirmDialog({
            message: `Are you sure you want to delete "${rowData.contact_Person_Name}(${rowData.contact_Person_Number})"?`,
            header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept: () => Remove(rowData),
            reject: () => rejectFunc()
        });
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-4">
            <div className="flex gap-4 w-full">
                {props.hasPermission("Contact", "Add") && (
                    <Button style={{ width: '80px', height: '30px' }} label="New" icon="pi pi-plus" className="p-button-rounded p-button-success" onClick={openNew} />
                )}
                <div className="w-full flex align-items-center justify-content-center">
                    <h4 style={{ margin: 0, textTransform: 'uppercase', fontFamily: 'Rancho', letterSpacing: 1 }}>Contact</h4>
                </div>
            </div>
            <div className="flex gap-4">
                {selectedContacts.length > 0 && props.hasPermission("Contact", "AssignLead") && (
                    <Button label="Generate Lead" icon="pi pi-plus" className="p-button-sm p-button-success p-button-rounded" onClick={() => { setOpenleadGenerateForm({ singleData: {}, open: true }); }} />
                )}

                <div className="p-input-icon-left">
                    <Search setSearch={setText} />
                </div>
                {props.hasPermission("Contact", "Export") && (
                    <Button style={{ width: '80px', height: '30px' }} label="Export" icon="pi pi-upload" className="p-button-sm p-button-rounded p-button-help" onClick={exportCSV} />
                )}
            </div>
        </div>
    );


    const actionBodyTemplate = (rowData: IContact) => {
        return (
            <div className="actions">
                {props.hasPermission("Contact", "Edit") && <Button icon="pi pi-pencil" className='p-button-success p-button-text p-0' onClick={() => openEdit(rowData)} />}
                {/* {props.hasPermission("Contact", "Remove") && <Button icon="pi pi-trash" className='p-button-danger p-button-text p-0' onClick={() => { confirmDelete(rowData) }} ></Button>} */}
            </div>
        );
    };

    const addressBody = (rowData: IContact) => {
        return (
            rowData.cityName ?
                <span>{rowData.cityName}, {rowData.stateName}, {rowData.countryName}</span> :
                <span>{rowData.stateName}, {rowData.countryName}</span>
        );
    }

    const createdAtBody = (rowData: any) => {
        return (
            <span>{rowData.createdAt ? format(new Date(rowData.createdAt + "Z"), 'dd/MM/yyyy') : '-'}</span>
        );
    }

    const ShowLeadGenerateForm = (rowData: any) => {
        setOpenleadGenerateForm({ singleData: rowData, open: true });
        console.log(openleadGenerateForm)
    };
    const rightToolbarTemplate = () => {
        const handleDownload = () => {
            const link = document.createElement("a");
            link.href = "/ContactSample.xlsx";
            link.download = "ContactSample.xlsx";
            link.click();
        };

        return (
            <>
                {props.hasPermission("Contact", "bulkUpload") &&
                    <div className="flex gap-3">
                        <Button
                            label="Bulk Upload"
                            icon="pi pi-upload"
                            className="p-button-success p-button-rounded h-3rem"
                            onClick={() => {
                                setOpenleadBulkUpload({ singleData: {}, open: true });
                            }}
                        />
                        <Button
                            label="Download Sample"
                            icon="pi pi-download"
                            className="p-button-info p-button-rounded h-3rem"
                            onClick={handleDownload}
                        />
                    </div>}
            </>
        );
    };



    const statusBody = (rowData: any) => {
        return (
            <>
                <Button icon="pi pi-plus-circle" className='p-button-info p-button-text p-0' onClick={() => { ShowLeadGenerateForm(rowData); }} />
            </>
        );
    }
    const leadStatusBody = (rowData: any) => {
        return rowData.leadAlreadyGenerated ? (
            <i className="pi pi-check-circle text-green-500" ></i>
        ) : (
            <i className="pi pi-times-circle text-red-500"></i>
        );
    };


    const copyToClipboard = async (value: any, type: any) => {
        if (!value) return;

        try {
            await navigator.clipboard.writeText(value);

            props.toast.current.show({
                severity: 'success',
                detail: `${type} copied successfully`,
                life: 1500
            });
        } catch (error) {
            console.error("Failed to copy:", error);
        }
    };


    const contactNumberBody = (rowData: IContact) => {
        return (
            <div className="flex align-items-center gap-2">
                <span>{rowData.contact_Person_Number || '-'}</span>

                {rowData.contact_Person_Number && (
                    <Button
                        icon="pi pi-copy"
                        className="p-button-text p-button-sm p-0"
                        tooltip="Copy contact number"
                        tooltipOptions={{ position: 'top' }}
                        onClick={() =>
                            copyToClipboard(
                                rowData.contact_Person_Number,
                                'Contact number'
                            )
                        }
                    />
                )}
            </div>
        );
    };


    const contactNameBody = (rowData: IContact) => {
        return (
            <div className="flex align-items-center gap-2">
                <span>{rowData.contact_Person_Name || '-'}</span>

                {rowData.contact_Person_Name && (
                    <Button
                        icon="pi pi-copy"
                        className="p-button-text p-button-sm p-0"
                        tooltip="Copy contact name"
                        tooltipOptions={{ position: 'top' }}
                        onClick={() =>
                            copyToClipboard(
                                rowData.contact_Person_Name,
                                'Contact name'
                            )
                        }
                    />
                )}
            </div>
        );
    };


    const emailBody = (rowData: IContact) => {
        return (
            <div className="flex align-items-center gap-2">
                <span>{rowData.contact_Person_Email || '-'}</span>

                {rowData.contact_Person_Email && (
                    <Button
                        icon="pi pi-copy"
                        className="p-button-text p-button-sm p-0"
                        tooltip="Copy email"
                        tooltipOptions={{ position: 'top' }}
                        onClick={() =>
                            copyToClipboard(
                                rowData.contact_Person_Email,
                                'Email'
                            )
                        }
                    />
                )}
            </div>
        );
    };
    return (
        <>
            <Toolbar className="mb-1 py-0" right={rightToolbarTemplate}></Toolbar>
            <Filter header={
                <div className="flex align-items-center justify-content-end gap-4">
                    Filter
                    <div className="flex align-items-center justify-content-end gap-2 ml-auto">
                        {/* {tableData.status.map((s) => {
                            // return (
                            //     // <Tag key={s.id} onClick={() => setFilter((prev) => ({ ...prev, statusId: s.id }))} severity={filter.status_ID === s.id ? 'warning' : 'info'} value={`${s.name}: ${s.count}`} rounded></Tag>
                            // )
                        })} */}
                    </div></div>} loading={tableData.loading} hasPermission={props.hasPermission} filter={filter} setFilter={setFilter} />
            <DataTable className="no-copy-table"

                style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" scrollHeight="70vh" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.data} lazy dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={tableData.count} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
                //isDataSelectable={(e) => !e.data.leadAlreadyGenerated}
                selectionMode="checkbox" selection={selectedContacts} onSelectionChange={(e) => setSelectedContacts(e.value)}

            >
                {props.hasPermission("Contact", "AssignLead") && <Column selectionMode="multiple"></Column>}

                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column header="Lead Generated" body={leadStatusBody} />
                <Column field="contact_Person_Name" header="Name" sortable body={contactNameBody} />
                <Column field="contact_Person_Number" header="Contact Number" sortable body={contactNumberBody} />
                <Column field="contact_Person_Email" header="Email" sortable body={emailBody} />
                <Column field="createdAt" header="Created At" sortable body={createdAtBody} />
                <Column field="createdByName" header="Created By" />
                <Column field="updated_ByName" header="Update By" />
                <Column field="address" header="Address" body={addressBody} />
                <Column field="source_Name" header="Source Name" />
                {/* <Column field="statusName" header="Add Lead" sortable body={statusBody} /> */}
                <Column body={actionBodyTemplate} />
            </DataTable>
            <ConfirmDialog />
            {/* <LeadGenerateForm contacts={selectedContacts} hasPermission={props.hasPermission} singleData={openleadGenerateForm.singleData} open={openleadGenerateForm.open} hideDialog={() => setOpenleadGenerateForm({ singleData: {}, open: false })}
                toast={props.toast}
                reloadData={props.reloadData}
            /> */}
            <BulkLeadLeadGenerateForm contacts={selectedContacts} hasPermission={props.hasPermission} singleData={openleadGenerateForm.singleData} open={openleadGenerateForm.open} hideDialog={() => setOpenleadGenerateForm({ singleData: {}, open: false })}
                toast={props.toast}
                reloadData={props.reloadData}
            />
            <BulkUploadForm hasPermission={props.hasPermission} singleData={openleadBulkUpload.singleData} open={openleadBulkUpload.open} hideDialog={() => setOpenleadBulkUpload({ singleData: {}, open: false })}
                toast={props.toast}
                reloadData={props.reloadData}
            />
        </>
    );
}
